import React, { ComponentProps } from "react";
import * as S from "./SecondaryLink.styles";
import { cleanReactChildren } from "../../__internal/_cleanReactChildren";
import type { ButtonLinkComponentProps } from "../Link";

export type SecondaryLinkProps = ButtonLinkComponentProps;

/**
 * Besides the color difference, secondary links have a different content
 * distribution than regular links.
 *
 * SecondaryLinks take an array of children. If there are at least two children,
 * it will behave like a mixed link but the underline will only cover the text.
 * If there's jutst one child it will render a regular link with extra padding
 * and different hover and focus styles.
 */
export const SecondaryLink = ({
  children,
  ...props
}: ComponentProps<typeof S.Layout>) => {
  // Positional children split (icon vs text) requires iterating children here.
  const childrenArray = cleanReactChildren(children);

  // Assume the first child is going to be the icon
  const icon = childrenArray.length > 1 && childrenArray[0];
  // Assume the rest will be the text
  const text =
    childrenArray.length > 1 ? childrenArray.slice(1) : childrenArray;

  return (
    <S.Layout {...props}>
      {icon && <S.Icon>{icon}</S.Icon>}
      <S.Text hasIcon={!!icon}>{text}</S.Text>
    </S.Layout>
  );
};
